import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchUser } from '../redux/slices/userSlice';

export const useUser = () => {
  const dispatch = useAppDispatch();
  const { data: user, loading, error } = useAppSelector((state) => state.user);

  useEffect(() => {
    // Trigger fetch if no user data and no active fetch or 4xx error
    if (!user && !loading && !error) {
      dispatch(fetchUser());
    }
  }, [dispatch, user, loading, error]);

  return {
    loading,
    error,
    ...user,
  };
};